module.exports = "<div class=\"splash-content\">\n  <div id=\"flashMessages\">\n    <div class=\"flash-message alert alert-danger\">\n      {{ error | translate }}\n    </div>\n  </div>\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/generic-error/generic-error.component.html
// module id = Kbn7
// module chunks = 0